import styled from '@emotion/styled';

const formBg = 'rgb(249, 249, 249)';
const primary = '#fec823';
const primary_dark = '#bb941f';

const Row = styled.div`
  width: 100%;
  margin: 30px auto;
  box-shadow: 0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 #ddd;
  border-radius: 4px;
  background-color: ${formBg};
  position: relative;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px auto;
`;

export default Row;
